import { diagnosticLog } from './diagnosticLogger';
import type { SignalPathZoneType } from './signalPath';

export type SignalPathNudgeAction = 'shown' | 'dismissed' | 'accepted';

export function logSignalPathZoneActivation(zoneType: SignalPathZoneType, zoneName?: string): void {
  diagnosticLog('info', 'signal-path', 'zone activated', {
    zone_type: zoneType,
    zone_name: zoneName ?? null,
  });
}

export function logSignalPathNudge(
  action: SignalPathNudgeAction,
  zoneType: SignalPathZoneType = 'system_audio',
): void {
  diagnosticLog('info', 'signal-path', `nudge ${action}`, {
    zone_type: zoneType,
    nudge_action: action,
  });
}
